import { useAppStore } from "@/hooks/useAppStore"
import { Sun, Moon, Wifi, Smartphone, Terminal, GitBranch } from "lucide-react"
import { Panel, SectionTitle, StatusIndicator } from "@/components/ui"

export default function SettingsPage() {
  const { theme, setTheme } = useAppStore()

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-semibold text-ink tracking-tight">Settings</h1>
        <p className="text-muted text-sm">AeroRocket dashboard configuration</p>
      </div>

      <Panel>
        <SectionTitle>Appearance</SectionTitle>
        <div className="p-3 space-y-3">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-ink">Theme</div>
              <div className="text-[0.625rem] text-muted">Dark graphite / light mode</div>
            </div>
            <button
              onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
              className="flex items-center gap-2 px-3 py-1.5 rounded-sm bg-surface border border-border text-xs font-medium text-ink hover:text-cyan-400 hover:border-cyan-500/50 transition"
            >
              {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
              <span>Switch to {theme === "dark" ? "light" : "dark"} mode</span>
            </button>
          </div>
        </div>
      </Panel>

      <Panel>
        <SectionTitle>System</SectionTitle>
        <div className="p-3 space-y-3">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded bg-surface border border-border flex items-center justify-center">
              <Wifi size={18} className="text-cyan-400" />
            </div>
            <div className="flex-1">
              <div className="text-sm text-ink">API connection</div>
              <StatusIndicator status="online" label="Connected to mission database" />
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded bg-surface border border-border flex items-center justify-center">
              <Smartphone size={18} className="text-amber-400" />
            </div>
            <div className="flex-1">
              <div className="text-sm text-ink">Responsive layout</div>
              <div className="text-[0.625rem] text-muted">Adapts to desktop and tablet viewports</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded bg-surface border border-border flex items-center justify-center">
              <Terminal size={18} className="text-blue-400" />
            </div>
            <div className="flex-1">
              <div className="text-sm text-ink">Simulation engine</div>
              <div className="text-[0.625rem] text-muted">Client-side physics mirroring the worker adapter</div>
            </div>
          </div>
        </div>
      </Panel>

      <Panel>
        <SectionTitle>About</SectionTitle>
        <div className="p-3 space-y-2">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded bg-surface border border-border flex items-center justify-center">
              <GitBranch size={16} className="text-muted" />
            </div>
            <div>
              <div className="text-sm text-ink">AeroRocket Dashboard</div>
              <div className="text-[0.625rem] text-muted">v0.2.0 &middot; aerospace mission control</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded bg-surface border border-border flex items-center justify-center">
              <Terminal size={16} className="text-muted" />
            </div>
            <div>
              <div className="text-sm text-ink">Backend</div>
              <div className="text-[0.625rem] text-muted">AeroRL Bench API &middot; FastAPI + SQLite</div>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  )
}
